// extracted by mini-css-extract-plugin
export var quantityInput = "_fw-0";